'use strict'

import {bootstrap} from '../bootstrap/bootstrap'

export function addLogoInteractionHandler(logo) {
  const logoE = logo.querySelector('path.e')
  logoE.addEventListener('mouseenter', () => {
    logo.classList.add('logo--active')
  }, false)
}

export function attachHamburgerHandler(hamburger, mobileNav) {
  hamburger.addEventListener('click', e => {
    e.preventDefault()
    hamburger.classList.toggle('hamburger--open')
    bootstrap(mobileNav, mobileNav => mobileNav.classList.toggle('navigation__mobile--open'))
  }, false)
}
